import { Link } from 'gatsby'
import React from 'react'
import { useConfigure, useInfiniteHits } from 'react-instantsearch'
import { css } from '@emotion/react'
import arrowRightPrimary from '../images/svgs/arrow-right-primary.svg'

const containerStyle = {
    display: 'flex', 
    flexDirection: 'column', 
    gap: 24 
}

const linkStyle = theme => css({
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    border: `1px solid ${theme.colors.mutedDark}`,
    padding: 16,
})

const imgStyle = { 
    maxWidth: 120,
}

const titleStyle = theme => css({ 
    fontFamily: theme.fonts.secondary,
    fontSize: 16,
    color: 'white',
})

const categoryStyle = theme => css({
    fontSize: 13,
    marginTop: 12,
    textTransform: 'uppercase',
    color: theme.colors.mutedLight,
})

const descriptionStyle = theme => css({
    textTransform: 'capitalize',
    color: theme.colors.mutedLight,
    marginTop: 12,
    marginBottom: 0,
})

const ctaStyle = theme => css({
    textTransform: 'uppercase',
    color: theme.colors.primary,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 0,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
})

// https://www.algolia.com/doc/api-reference/widgets/infinite-hits/react/#hook-usage
export default function Results() {
    useConfigure({ hitsPerPage: 3 })
    const { results } = useInfiniteHits()
    
    if (!results.hits.length) return
    else return (
        <div css={containerStyle}>
            {results.hits.map(hit => {
                return (
                    <Link className='product-card' to={hit.data.url} key={hit.objectID} css={linkStyle}>
                        <img
                            src={hit.data.thumbnail} 
                            alt={hit.data.name}
                            css={imgStyle}
                        />
                        <div css={{
                            flexGrow: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 40,
                            '@media(max-width: 576px)': {
                                flexDirection: 'column',
                                gap: 8,
                            }
                        }}>
                            <span css={{ flexShrink: 1 }}>
                                <h5 css={titleStyle}>
                                    {hit.data.name}
                                </h5>
                                <h6 css={categoryStyle}>
                                    {hit.data.categories.lvl0}
                                </h6>
                                <p css={descriptionStyle}>
                                    {hit.data.shortDescription}
                                </p>
                            </span>
                            <span className='product-card-cta' css={ctaStyle}>
                                Discover
                                <img src={arrowRightPrimary} alt="Arrow" />
                            </span>
                        </div>
                    </Link>
                )
            })}
        </div>
    )
}
